import { MARKETPLACE_PRODUCTS, MarketplaceProduct } from '../pages/Marketplace/marketplaceCatalog';

// Ruteo unificado servicio -> página de detalle.
// Fuente de verdad: los tipos "core" (no-marketplace) se mapean aquí, y el resto
// se resuelve desde marketplaceCatalog.ts por `apiCategory`. Así, agregar un
// producto nuevo al catálogo hace que su card, su "Ver servicio" y su ícono
// funcionen sin tocar más lugares.

type RouteFn = (id: string) => string;

const CORE_ROUTES: Array<{ match: (cat: string) => boolean; route: RouteFn }> = [
  { match: (c) => c === 'APP_DEPLOY' || c === 'DEPLOY-APP' || c === 'APP', route: (id) => `/deploy-apps/${id}` },
  { match: (c) => c === 'VM' || c === 'COMPUTE' || c === 'VIRTUAL-MACHINE', route: (id) => `/virtual-machines/${id}` },
  { match: (c) => c === 'DATABASE' || c === 'DB', route: (id) => `/databases/${id}` },
  { match: (c) => c === 'SITE', route: (id) => `/sites/${id}` },
  { match: (c) => c === 'AI_SERVICE' || c === 'IA_SERVICE', route: (id) => `/chatbot-ia/${id}` },
  { match: (c) => c === 'APP-SERVER' || c === 'BLUEPRINT', route: (id) => `/stacks/${id}` },
  { match: (c) => c === 'WORDPRESS_LIGHTSAIL', route: (id) => `/services/${id}` },
];

export function getMarketplaceProductByCategory(
  categoryOrType: string | undefined | null
): MarketplaceProduct | null {
  const cat = (categoryOrType || '').toUpperCase();
  if (!cat) return null;
  return MARKETPLACE_PRODUCTS.find((p) => (p.apiCategory || '').toUpperCase() === cat) || null;
}

/**
 * Devuelve la ruta de detalle correcta para un servicio según su categoría/tipo.
 * Cubre los tipos core y todos los productos de marketplace (via catálogo).
 * Fallback: /services/{id} (detalle genérico).
 */
export function getServiceDetailRoute(categoryOrType: string | undefined | null, id: string): string {
  if (!id) return '/services';
  const cat = (categoryOrType || '').toUpperCase();

  for (const c of CORE_ROUTES) {
    if (c.match(cat)) return c.route(id);
  }

  const product = getMarketplaceProductByCategory(cat);
  if (product) return product.detailRoute(id);

  return `/services/${id}`;
}
